"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var test_attributes_1 = require("@carvana/test-attributes");
var react_1 = require("react");
var Carousel_styles_1 = require("./Carousel.styles");
var Carousel = function (_a) {
    var carouselHeaderComponent = _a.carouselHeaderComponent, carouselAriaLabel = _a.carouselAriaLabel, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, trackEvent = _a.trackEvent;
    var totalNumOfSlides = react_1.Children.count(children);
    var carouselRef = (0, react_1.useRef)(null);
    var slidesRef = (0, react_1.useRef)(null);
    var storedDimensionsRef = (0, react_1.useRef)({
        carouselWidth: 0,
        slideWidth: 0,
        totalSlidesWidth: 0
    });
    var trackingRef = (0, react_1.useRef)({
        reachedEnd: false,
        totalSlides: totalNumOfSlides,
        userInteracted: false,
        visibleSlides: 0
    });
    var _c = (0, react_1.useState)(false), showArrows = _c[0], setShowArrows = _c[1];
    var _d = (0, react_1.useState)(true), prevDisabled = _d[0], setPrevDisabled = _d[1];
    var _e = (0, react_1.useState)(false), nextDisabled = _e[0], setNextDisabled = _e[1];
    var handleNextClick = function () {
        slidesRef.current.scrollBy(storedDimensionsRef.current.slideWidth, 0);
    };
    var handlePrevClick = function () {
        slidesRef.current.scrollBy(-storedDimensionsRef.current.slideWidth, 0);
    };
    (0, react_1.useLayoutEffect)(function () {
        var initializeDimensions = function () {
            var carouselNode = carouselRef.current;
            var slidesNode = slidesRef.current;
            var carouselWidth = carouselNode.getBoundingClientRect().width;
            var totalSlidesWidth = slidesNode.scrollWidth;
            var firstSlide = slidesNode.querySelectorAll("[aria-roledescription=\"slide\"]")[0];
            var slideWidth = firstSlide.getBoundingClientRect().width;
            if (totalSlidesWidth <= carouselWidth) {
                setShowArrows(false);
            }
            else {
                setShowArrows(true);
            }
            storedDimensionsRef.current = {
                carouselWidth: carouselWidth,
                slideWidth: slideWidth,
                totalSlidesWidth: totalSlidesWidth
            };
            trackingRef.current.visibleSlides = Math.floor(carouselWidth / slideWidth);
        };
        var resizeObserver = new ResizeObserver(function () {
            initializeDimensions();
        });
        resizeObserver.observe(carouselRef.current);
        return function () {
            resizeObserver.unobserve(carouselRef.current);
        };
    }, [totalNumOfSlides]);
    (0, react_1.useLayoutEffect)(function () {
        var handleScroll = function () {
            var slidesNode = slidesRef.current;
            var storedDimensions = storedDimensionsRef.current;
            var atEnd = slidesNode.scrollLeft + storedDimensions.carouselWidth >= storedDimensions.totalSlidesWidth;
            setPrevDisabled(slidesNode.scrollLeft <= 0);
            setNextDisabled(atEnd);
            if (trackEvent) {
                if (!trackingRef.current.userInteracted) {
                    trackingRef.current.userInteracted = true;
                    trackingRef.current.reachedEnd = atEnd;
                    trackEvent(trackingRef.current);
                }
                else if (!trackingRef.current.reachedEnd && atEnd) {
                    trackingRef.current.reachedEnd = atEnd;
                    trackEvent(trackingRef.current);
                }
            }
        };
        var timer = null;
        var debouncedScroll = function () {
            clearTimeout(timer);
            timer = setTimeout(handleScroll, 50);
        };
        var slidesNode = slidesRef.current;
        slidesNode.addEventListener('scroll', debouncedScroll);
        return function () {
            clearTimeout(timer);
            slidesNode.removeEventListener('scroll', debouncedScroll);
        };
    }, []);
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    return ((0, jsx_runtime_1.jsxs)(Carousel_styles_1.CarouselWrapper, __assign({ className: className, "aria-label": carouselAriaLabel, "aria-roledescription": "carousel", ref: carouselRef }, getTestAttributes('carousel'), { role: "region" }, { children: [(0, jsx_runtime_1.jsxs)(Carousel_styles_1.TopSection, { children: [(0, jsx_runtime_1.jsx)(Carousel_styles_1.CarouselHeaderWrapper, { children: carouselHeaderComponent ? ((0, jsx_runtime_1.jsx)(Carousel_styles_1.CarouselHeader, { children: carouselHeaderComponent })) : null }), showArrows && ((0, jsx_runtime_1.jsxs)(Carousel_styles_1.Arrows, { children: [(0, jsx_runtime_1.jsx)(Carousel_styles_1.ArrowButton, __assign({ "aria-label": "Previous slides", onClick: handlePrevClick, disabled: prevDisabled }, { children: (0, jsx_runtime_1.jsx)(Carousel_styles_1.ArrowCircleStyled, { "aria-hidden": "true", focusable: false }) })), (0, jsx_runtime_1.jsx)(Carousel_styles_1.ArrowButton, __assign({ "aria-label": "Next slides", onClick: handleNextClick, disabled: nextDisabled }, { children: (0, jsx_runtime_1.jsx)(Carousel_styles_1.ArrowCircleStyled, { "aria-hidden": "true", focusable: false, direction: "right" }) }))] }))] }), (0, jsx_runtime_1.jsx)(Carousel_styles_1.Slides, __assign({ dir: "ltr", ref: slidesRef }, { children: react_1.Children.map(children, function (child, idx) { return ((0, jsx_runtime_1.jsx)(Carousel_styles_1.ChildWrapper, __assign({ role: "group", "aria-roledescription": "slide", "aria-label": "slide ".concat(idx + 1, " of ").concat(totalNumOfSlides) }, { children: child }))); }) }))] })));
};
exports.Carousel = Carousel;
